module.exports = __webpack_public_path__ + "img/cherokee.1cf62c38.png";